<div class="container">
    <router-outlet />
</div>
